<template>
    <div class="col-xs-12 col-md-10">
        <div class="card-content col-sm-10 col-sm-offset-2 blogPost">
            <h2 v-html="title">
            </h2>
            <div class="content">
                <p class="subtitle">{{date}}</p>
                <p v-html="content"></p>
            </div>
            <footer class="card-footer">
                <router-link :to="{path: 'comments', query: {postID: postId}}">Read Comments</router-link>
                <router-view></router-view>
            </footer>
        </div>
    </div>
</template>


<script>
import axios from 'axios';
import { HOSTNAME, AUTHORIZATION, APIENDPOINTS } from '../const/urls';
export default {
    name: 'post-list',
    props: ['postId'],
    data: function() {
        return {
            date: '',
            title: '',
            content: '',
            comments: '',
        }
    },
    methods: {
        getPost: function() {

            axios({
                method: 'get',
                url: HOSTNAME + APIENDPOINTS.POST + this.postId,
                auth: {
                    username: AUTHORIZATION.USERNAME,
                    password: AUTHORIZATION.PASSWORD
                }
            }).then(message => {
                this.date = message.data.date;
                this.title = message.data.title.rendered;
                this.content = message.data.content.rendered;
            })

        },

    },
    beforeMount: function() {
        this.getPost();
    }
}

</script>


<style scoped>

</style>


// WEBPACK FOOTER //
// src/js/components/PostItem.vue?f66ff8fc